<section class="comp-contact-info">
  <p-dialog *ngIf="contactToEdit&&displayDialog" [(visible)]="displayDialog"
            header="Contact Information" [dismissableMask]="true" [responsive]="true" [modal]="true" [style]="PrimeNgConfig.DialogStyle40" [contentStyle]="{'overflow-y':'auto'}">
    <form #dialogForm="ngForm">
      <p *ngIf="errMsgForRepeatedMainContact&&errMsgForRepeatedMainContact.length>1" class="growl-submit">
        {{errMsgForRepeatedMainContact}}
      </p>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label> Type*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown required name="contactType" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [style]="{'width':'100%'}"
                      [options]="contactTypeDropDown"
                      [(ngModel)]="contactToEdit.contactType"
                      (onChange)="onChangeContactType(contactToEdit.contactType)"
                      [disabled]="disabledBillingContact" ></p-dropdown>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>First Name*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input required pInputText name="firstName" type="text" [maxLength]="Validation.FirstLastNameMaxLength"
                 [(ngModel)]="contactToEdit.firstName"
                 (change)="validateUniqueContact()"
                 [disabled]="disabledBillingContact" >
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Last Name*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input required pInputText name="lastName" type="text" [maxLength]="Validation.FirstLastNameMaxLength"
                 [(ngModel)]="contactToEdit.lastName"
                 (change)="validateUniqueContact()"
                 [disabled]="disabledBillingContact" >
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Title</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText name="title" type="text" [maxLength]="Validation.ContactTitleMaxLength"
                 [disabled]="disabledBillingContact"
                 [(ngModel)]="contactToEdit.title">
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Address Name/Type</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="addressName" [placeholder]="Validation.DropdownPlaceholder" [showClear]="true"
                      [options]="addrNameDropDown"
                      [(ngModel)]="selectedAddress"
                      (onChange)="validateUniqueContact()"></p-dropdown>
        </div>
      </div>
      <div class="p-grid" [ngStyle]="{'pointer-events':(disabledBillingContact) ? 'none' : 'auto' }">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Work Phone</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <app-international-phone-number name="officePhone" [(ngModel)]="contactToEdit.officePhone"></app-international-phone-number>
        </div>
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Ext</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-inputMask name="ext" [unmask]="true" placeholder="x9999" mask="9999" [maxlength]="Validation.OfficePhoneExtMaxLength"
                       [(ngModel)]="contactToEdit.officePhoneExt"
                       [disabled]="disabledBillingContact"></p-inputMask>
        </div>
      </div>
      <div class="p-grid" [ngStyle]="{'pointer-events':(disabledBillingContact) ? 'none' : 'auto' }">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Fax Phone</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <app-international-phone-number name="faxPhone" [(ngModel)]="contactToEdit.faxPhone"></app-international-phone-number>
        </div>
      </div>
      <div class="p-grid" [ngStyle]="{'pointer-events':(disabledBillingContact) ? 'none' : 'auto' }">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Mobile Phone</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <app-international-phone-number name="mobilePhone" [(ngModel)]="contactToEdit.mobilePhone"></app-international-phone-number>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Email*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input required pInputText name="email" type="email" [pattern]="RegExpEmail" [maxLength]="Validation.EmailMaxLength"
                 [disabled]="disabledBillingContact"
                 [(ngModel)]="contactToEdit.email" >
        </div>
      </div>

    </form>
    <p-footer>
      <div style="margin:15px;text-align:right;">
        <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel"
                (click)="closeDialog()"></button>
        <button *ngIf="!selectedContact"
                pButton type="button" class="button-action" icon="fa fa-check" label="Add"
                (click)="addContact(contactToEdit, selectedAddress)"
                [disabled]="!dialogForm.form.valid ||!showAddContactBtn">
        </button>
        <button *ngIf="selectedContact"
                pButton type="button" class="button-action" icon="fa fa-check" label="Update"
                (click)="updateContact(contactToEdit, selectedAddress)"
                [disabled]="!dialogForm.form.valid">
        </button>
      </div>
    </p-footer>
  </p-dialog>

  <app-data-table #dt [columns]="contactColumns" [value]="contacts" sortField="contactType" [sortOrder]="PrimeNgConfig.TableAscSortOrder" [(selection)]="selectedContact"
                  [leftCaptionTemplate]="leftCaption" [rightCaptionTemplate]="rightCaption" [bodyTemplate]="bodyTemplate">
    <ng-template #leftCaption>
      <p-checkbox name="billingContactSameAsMain" binary="true" label="Billing contact same as Main"
                  [(ngModel)]="tradingPartner.billingContactSameAsMain"
                  (onChange)="addBillingContactIfSameAsMain(tradingPartner.billingContactSameAsMain)"></p-checkbox>
    </ng-template>

    <ng-template #rightCaption>
      <button pButton type="button" class="add wrapper action-secondary" icon="fa fa-plus" iconPos="left" label="Contact"
              (click)="showAddContact()"></button>
    </ng-template>

    <ng-template #bodyTemplate let-row="row" let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" [ngSwitch]="col.field" style="overflow:ellipsis;word-break:break-all;">
          <span class="p-column-title">{{col.header}}</span>
          <span class="p-cell">
            <div *ngSwitchCase="'contactType'"> {{row.contactType | titleCase}} </div>
            <div *ngSwitchCase="'firstName'"> {{row.firstName}} {{row.lastName}} </div>
			      <div *ngSwitchCase="'addrName'"> {{row.addrName | titleCase}} {{row.addrName && row.addrType ? '-' : ''}} {{row.addrType | titleCase}} </div>
            <div *ngSwitchCase="'mainPhone'"> {{row.mainPhone | phone}}</div>
            <div *ngSwitchCase="'faxPhone'">{{row.faxPhone | phone}}</div>
            <div *ngSwitchCase="'mobilePhone'">{{row.mobilePhone | phone}}</div>
            <div *ngSwitchCase="'officePhone'">
              <div *ngIf="row.officePhone && !row.officePhoneExt"> {{row.officePhone | phone }}</div>
              <div *ngIf="row.officePhone && row.officePhoneExt"> {{row.officePhone | phone}} x{{row.officePhoneExt}}</div>
            </div>

            <div *ngSwitchDefault>{{row[col.field]}}</div>

            <div *ngSwitchCase="'action'" text-align="center">
              <button pButton type="button" class="icon-button icon-action" icon="fa fa-pencil"
                      (click)="showEditContact(row)">
              </button>
              <button pButton type="button" class="icon-button icon-negative" icon="fa fa-trash"
                      (click)="deleteContact(row)"
                      [disabled]="row && (row?.contactType === ExternalContactType.Main || row?.contactType === ExternalContactType.Billing)">
           </button>
            </div>
          </span>
        </td>
      </tr>
    </ng-template>
  </app-data-table>

  <p-confirmDialog></p-confirmDialog>

</section>
